module.exports = __webpack_public_path__ + "static/media/CatalogBakkiicookii.fa4c92bf.pdf";